module.exports = require('./assign');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/object/extend.js
 ** module id = 497
 ** module chunks = 0 1
 **/